/** @format */

export type Granularity = 'year' | 'month' | 'day' | 'hour' | 'minute';
